import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const REPORTS_LIST = "reports_list";
export const REPORTS_SIMPLE_LIST = "reports_simple_list";
export const CREATE_REPORT = "create_report";
export const UPDATE_REPORT = "update_report";
export const UPDATE_REPORT_STATUS = "UPDATE_REPORT_STATUS";
export const DELETE_REPORT = "delete_report";
export const GET_REPORT_DETAILS = "get_report_details";
export const REPORT_TRANSACTIONS_LIST = "REPORT_TRANSACTIONS_LIST";
export const REPORT_ADS_LIST = "REPORT_ADS_LIST";
export const REPORT_YEARLY_GRAPH = "REPORT_YEARLY_GRAPH";
export const REPORT_PT_GRAPH = "REPORT_PT_GRAPH";
export const REPORT_PPSF_GRAPH = "REPORT_PPSF_GRAPH";
export const REPORT_PBB_GRAPH = "REPORT_PBB_GRAPH";
export const REPORT_PBB_TABLE = "REPORT_PBB_TABLE";
export const REPORT_LISTING_PRICE = "REPORT_LISTING_PRICE";
export const REPORT_TRANSACTIONS_TITLES = "REPORT_TRANSACTIONS_TITLES";
export const GET_REPORT = "GET_REPORT";
export const GET_REPORT_TABLE = "GET_REPORT_TABLE";
export const CLEAR_REPORT_ERRORS = "clearReportsErrors";

// mutation types
export const SET_REPORT_ERROR = "setReportsError";
export const REMOVE_REPORT_ERRORS = "removeReportsErrors";

const state = {
    errors: null,
    sharedReportLink: '',
};
const actions = {
    [REPORTS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reports?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORTS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [GET_REPORT_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getreportdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [CREATE_REPORT](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createreport", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_REPORT_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [UPDATE_REPORT](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatereport", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_REPORT_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [UPDATE_REPORT_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatereportstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_REPORT_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [DELETE_REPORT](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletereport", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_REPORT_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_TRANSACTIONS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/reporttransactionslist?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_ADS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/reportadslist?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_YEARLY_GRAPH](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportyearlygraph?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_PT_GRAPH](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportptgraph?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_PPSF_GRAPH](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportavgppsfgraph?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_PBB_GRAPH](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportavgpbbgraph?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_PBB_TABLE](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reportavgpbbtable?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_TRANSACTIONS_TITLES](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/reporttransactionstitles?q=" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [REPORT_LISTING_PRICE](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/listingpricereport?ref=" + payload.ref + '&tkn=' + payload.tkn + '&okn=' + payload.okn)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [GET_REPORT](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getreport?" + payload.q)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [GET_REPORT_TABLE](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/getreporttable?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_REPORT_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_REPORT_ERROR, response.errors);
                });
        });
    },
    [CLEAR_REPORT_ERRORS](context) {
        context.commit(REMOVE_REPORT_ERRORS);
    },
};

const mutations = {
    [SET_REPORT_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_REPORT_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
